import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Inject,
  NgModule,
  NgZone,
  ViewEncapsulation,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SafeUrlPipeModule } from '../../pipes/safe-url.pipe';
import { GenericModalService } from '../../shared/generic-modal/generic-modal.service';
import { IframeActivityModalBase } from '../../shared/iframe-activity-modal/iframe-activity-modal.base';
import { IframeActivityModalData } from '../../shared/iframe-activity-modal/iframe-activity-modal-data';
import { ImmersionCourseService } from '../../shared/immersion-course.service';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { OeAppService } from '../../shared/oe-app.service';
import { MODAL_DATA } from '../../shared/tokens/modal-data.token';
import { TranslatePipe, TranslatePipeModule } from '../../shared/translate.pipe';
import { CourseContentType } from '../../shared/types/course-content-type';
import { InteractiveVideosEventType } from '../../shared/types/interactive-videos-events.enum';
import { UserwaySyncModule } from '../../shared/userway-sync.directive';

export const INTERACTIVE_VIDEOS_MODAL_TITLE_ID = 'interactive-videos-modal-title';

@Component({
  selector: 'lp2-interactive-videos-modal',
  styleUrls: ['./interactive-videos-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  template: `
    <h2 id="${INTERACTIVE_VIDEOS_MODAL_TITLE_ID}" class="sr-only">{{ 'studybundle.videos.title' | translate }}</h2>
    <iframe
      [lp2UserwaySync]="targetOrigin"
      *ngIf="url$ | async as url"
      [src]="url | safeUrl"
      frameborder="0"
      sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
      allow="autoplay; fullscreen; microphone"
      [height]="height"
      [attr.title]="'studybundle.videos.title' | translate"
      class="interactive-videos-modal-iframe"
      data-test-id="interactive-videos-modal-iframe"
    >
    </iframe>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InteractiveVideosModalComponent extends IframeActivityModalBase {
  @HostBinding('class.interactive-videos-modal') readonly hostClass = true;
  // BaseNotificationModalComponent reads this: the embedded app has its own close control,
  // but with no host no iframe renders and the static backdrop would trap the student
  get showCloseButton(): boolean {
    return !this.getHost();
  }
  protected readonly closeEventType = InteractiveVideosEventType.INTERACTIVE_VIDEOS_CLOSE_EVENT;
  protected readonly heightEventType = InteractiveVideosEventType.INTERACTIVE_VIDEOS_HEIGHT_EVENT;
  protected readonly reportActivityProgressEventType =
    InteractiveVideosEventType.INTERACTIVE_VIDEOS_REPORT_ACTIVITY_PROGRESS_EVENT;
  protected readonly courseContentType = CourseContentType.VIDEOS;
  // the app reports progress after its own close confirm, so a failed save must not strand the student
  protected readonly closeOnSaveError = true;

  constructor(
    private readonly oeApp: OeAppService,
    private readonly oeAppPersonService: OeAppPersonService,
    activeModal: NgbActiveModal,
    cdRef: ChangeDetectorRef,
    ngZone: NgZone,
    immersionCourseService: ImmersionCourseService,
    genericModalService: GenericModalService,
    translatePipe: TranslatePipe,
    @Inject(MODAL_DATA) modalData: IframeActivityModalData
  ) {
    super(activeModal, cdRef, ngZone, immersionCourseService, genericModalService, translatePipe, modalData);
  }

  protected getHost(): string {
    return this.oeApp.webInteractiveVideosHost;
  }

  protected buildUrl(): string {
    return `${this.oeApp.webInteractiveVideosHost}?env=${encodeURIComponent(
      this.oeApp.environment
    )}&lang=${encodeURIComponent(this.oeAppPersonService.preferredLang)}&interactiveVideoId=${
      this.modalData.item.mediaData
    }`;
  }
}

@NgModule({
  imports: [CommonModule, TranslatePipeModule, SafeUrlPipeModule, UserwaySyncModule],
  declarations: [InteractiveVideosModalComponent],
  entryComponents: [InteractiveVideosModalComponent],
  exports: [InteractiveVideosModalComponent],
})
export class InteractiveVideosModalModule {}



// WEBPACK FOOTER //
// ./ts/app/components/interactive-videos-modal/interactive-videos-modal.component.ts